import { Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { PopoverController } from '@ionic/angular';
import { StatusPopoverComponent } from '../status-popover/status-popover.component';
import { BackendCallService } from 'src/app/services/backend-call/backend-call.service';
import { ShareValuesService } from '../../services/sharedValues/share-values.service';
import AOS from 'aos';
import { ToastService } from 'src/app/services/toast.service';
import { AppConstants, appLanguageLabels, appLanguageOptions } from 'src/app/utilities/constant';
import { UserAuthService } from 'src/app/services/user-auth/user-auth.service';
import { EnhancedNotificationComponent } from '../enhanced-notification/enhanced-notification.component';
import { TranslateService } from '@ngx-translate/core';
import { LanguageSupportService } from 'src/app/services/language-support.service';
import { UnsavedChangesService } from 'src/app/services/unsaved-changes.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  @ViewChild('search') search: any;
  @ViewChild('profileTrigger', { read: ElementRef }) profileTrigger!: ElementRef<HTMLElement>;
  @ViewChild('languageTrigger', { read: ElementRef }) languageTrigger!: ElementRef<HTMLElement>;
  @ViewChildren('languageOption', { read: ElementRef }) languageOptionRefs!: QueryList<ElementRef<HTMLElement>>;
  @ViewChild('enhancedNotification') enhancedNotification: EnhancedNotificationComponent;
  isItemAvailable = false;
  toggled = false;
  isinputitems = false;
  dummyData = [];
  suggestions: any[] = [];
  searchedProject: any;
  searchValue: any;
  itemsToLoad = 10; // Number of items to load
  isLoading = true;
  userInfo: any;
  logoSrc = 'assets/images/blue-print-Logo.svg';
  notificationUnreadCount = 0;
  public isUserProfilePopupOpen = false;
  selectedLanguage: string;
  isLanguageDropdownOpen = false;
  languages = appLanguageLabels;
  languageOptions = appLanguageOptions;
  orderedLanguageOptions = [];
  private notificationSub: any;
  private profilePopover: HTMLIonPopoverElement | null = null;
  constructor(
    private router: Router,
    private popController: PopoverController,
    public sharedValue: ShareValuesService,
    public backendService: BackendCallService,
    private toastService: ToastService,
    public userAuthService: UserAuthService,
    private translate: TranslateService,
    private languageSupportService: LanguageSupportService,
    private unsavedChangesService: UnsavedChangesService
  ) {
    this.selectedLanguage = this.languageSupportService.getDefaultLanguage();
    this.reorderLanguageOptions();
  }

  ngOnInit() {
    AOS.init(); // Initialize AOS in the component
    this.loadItems();
    this.userInfo = this.userAuthService.getUserList();
    // Subscribe to notifications$ for real-time count
    this.notificationSub = this.sharedValue.notifications$.subscribe(notifications => {
      this.notificationUnreadCount = notifications.filter(n => !n.isRead).length;
    });
    console.log(this.notificationSub, 'notificationSub');
  }

 public async toggleUserProfilePopup(event: Event): Promise<void> {
    if (this.isUserProfilePopupOpen && this.profilePopover) {
      await this.closePopOver();
      this.profileTrigger?.nativeElement.focus();
      return;
    }

    await this.openLanSettings(event, 'openChangeLan');

    // Keep focus on trigger after open (your requirement)
    setTimeout(() => {
      this.profileTrigger?.nativeElement.focus();
    }, 0);
  }

public closeNotificationPopup () : void {
  if (this.enhancedNotification?.isVisible) {
      this.enhancedNotification.closePopup();
    }
}

  public toggleNotificationPopup(): void {
    if (this.enhancedNotification?.isVisible) {
      this.enhancedNotification.closePopup();
    } else {
      this.showNotification();
    }
  }
  loadItems() {
    // Simulate fetching items from an API
    setTimeout(() => {
      const newItems = Array.from({ length: this.itemsToLoad }, (_, i) => `Item ${i + 1}`);
      this.suggestions = newItems;
      this.isLoading = false;
    }, 1000);
  }


  outsideClick(clickedOutside: boolean) {
    if (!clickedOutside) {
      return;
    }

    this.suggestions = [];
    this.isItemAvailable = false;
    this.isLanguageDropdownOpen = false;
  }

  onSearch(event) {
    const searchTerm = event.target.value;
    if(event.target.value === '') {
      this.suggestions = [];
      this.isItemAvailable = false;
    } else if (searchTerm.length >= 3) {
      this.isItemAvailable = true;
      const payload = {
        search: searchTerm,
        top: 50,
        suggesterName: 'qa-suggester'
      };
      this.backendService.getAutocompleteSuggestions(payload).subscribe(
        (suggestions: any) => {
          if(suggestions.value.length === 0) {
            this.toastService.presentToast(this.translate.instant('no_search_result_found'), 4000, AppConstants.WARNING_SNACKBAR, 'top');
          }else {
            this.suggestions = [];
            suggestions.value.forEach(element => {
              const each = {
                name: element['@search.text'],
                projectID: element.project_Id,
              };
              this.suggestions.push(each);
            });
          }
        }
      );
    }
  }

  serachTerm(val) {
    this.searchValue = val;
    this.sharedValue.globalSearchInput = val;
    const alpbheticWithSpace = /[a-zA-Z]+([\s][a-zA-Z]+)*/;
    let fullSearch;
    const alpbhetic = /^[A-Za-z]+$/;
    if (this.searchValue.match(alpbhetic)) {
      this.searchValue = val + '*';
    } else if (this.searchValue.toString().includes('-')) {
      const alpbheticNumericWithSpl = /^[ A-Za-z0-9_@./#&+-]*$/;
      const subStirng = this.searchValue.toString().slice(this.searchValue.toString().indexOf('-') + 1);
      if (this.searchValue.match(alpbheticNumericWithSpl) && subStirng.length < 5) {
        fullSearch = false;
        this.searchValue = '/' + '.' + '*' + val.trim() + '.' + '*' + '/';
      } else {
        fullSearch = true;
        this.searchValue = '"' + val.toString() + '"';
      }
    }
    else if (this.searchValue.match(alpbheticWithSpace)) {
      fullSearch = true;
      this.searchValue = '"' + val.toString() + '"';
    } else {
      fullSearch = true;
      this.searchValue = '/' + '.' + '*' + val.trim() + '.' + '*' + '/';
    }

    // if the value is an empty string don't filter the items
    if (val && val.trim() !== '') {
      this.isItemAvailable = true;
      this.dummyData = this.dummyData.filter((item) => item.name.toLowerCase().indexOf(val.toLowerCase()) > -1);
      this.viewAllResults(fullSearch);
    } else {
      this.isItemAvailable = false;
      // this.isinputitems = false
    }
  }

  async viewAllResults(fullSearch: boolean) {
    if (this.searchValue) {
      const canLeave = await this.unsavedChangesService.canLeave('route');
      if (!canLeave) {
        return;
      }

      this.isItemAvailable = false;
      this.isinputitems = true;
      this.sharedValue.intiazureSearch(this.searchValue, fullSearch);
      const navigationExtras: NavigationExtras = {
        state: {
          globalSearchInput: this.searchValue
        },
      };
      this.router.navigate(['view-all-search-results'], navigationExtras);
    }
  }

   showNotification() {
    if (this.enhancedNotification) {
      this.enhancedNotification.showPopup();
    }
   }

  async languageChange(): Promise<boolean> {
    const canLeave = await this.unsavedChangesService.canLeave('route');
    if (!canLeave) {
      return false;
    }

    this.languageSupportService.setLanguage(this.selectedLanguage);
    try {
      const didNavigate = await this.router.navigate(['/dashboard']);
      if (didNavigate) {
        window.location.reload();
      }
      return didNavigate;
    } catch (error) {
      console.error('Failed to navigate to dashboard:', error);
      window.location.reload();
      return false;
    }
  }

  toggleLanguageDropdown() {
    this.reorderLanguageOptions();
    this.isLanguageDropdownOpen = !this.isLanguageDropdownOpen;

    if (this.isLanguageDropdownOpen) {
      this.focusLanguageOption(0);
    }
  }

  onLanguageTriggerKeydown(event: KeyboardEvent): void {
    if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') {
      return;
    }

    event.preventDefault();
    this.reorderLanguageOptions();

    if (!this.isLanguageDropdownOpen) {
      this.isLanguageDropdownOpen = true;
    }

    if (event.key === 'ArrowUp') {
      this.focusLanguageOption(this.orderedLanguageOptions.length - 1);
      return;
    }

    this.focusLanguageOption(0);
  }

  onLanguageOptionKeydown(event: KeyboardEvent, index: number): void {
    const optionCount = this.orderedLanguageOptions.length;
    if (!optionCount) {
      return;
    }

    if (event.key === 'Tab') {
      event.preventDefault();
      this.isLanguageDropdownOpen = false;
      setTimeout(() => {
        this.moveFocusOutsideLanguageDropdown(event.shiftKey);
      }, 0);
      return;
    }

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.focusLanguageOption((index + 1) % optionCount);
      return;
    }

    if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.focusLanguageOption((index - 1 + optionCount) % optionCount);
      return;
    }

    if (event.key === 'Home') {
      event.preventDefault();
      this.focusLanguageOption(0);
      return;
    }

    if (event.key === 'End') {
      event.preventDefault();
      this.focusLanguageOption(optionCount - 1);
      return;
    }

    if (event.key === 'Escape') {
      event.preventDefault();
      this.isLanguageDropdownOpen = false;
      this.languageTrigger?.nativeElement.focus();
      return;
    }

    if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
      event.preventDefault();
      const language = this.orderedLanguageOptions[index];
      if (language) {
        this.selectLanguage(language.code);
      }
    }
  }

  getSelectedLanguageLabel() {
    const selectedCode = this.selectedLanguage || 'en';
    const selectedLabel = this.languages[selectedCode] || this.languages.en;
    return `${selectedLabel} (${selectedCode})`;
  }

  async selectLanguage(languageCode: string) {
    const previousLanguage = this.selectedLanguage;
    this.selectedLanguage = languageCode;
    this.reorderLanguageOptions();
    this.isLanguageDropdownOpen = false;
    const didChangeLanguage = await this.languageChange();
    if (!didChangeLanguage) {
      this.selectedLanguage = previousLanguage;
      this.reorderLanguageOptions();
    }
  }

  async openLanSettings(ev: any, type) {
    const props = { type };
    const popover = await this.popController.create({
      component: StatusPopoverComponent,
      cssClass: 'profile-popover',
      event: ev,
      translucent: true,
      componentProps: props,
      showBackdrop: false,
      // mode: 'ios',
    });

    this.profilePopover = popover;
    await popover.present();

    this.isUserProfilePopupOpen = true;
    this.profileTrigger?.nativeElement.focus();

    await popover.onDidDismiss().then(() => {
      this.profilePopover = null;
      this.isUserProfilePopupOpen = false;
      this.profileTrigger?.nativeElement.focus();
    });
  }

  /**
   * Closes popover
   */
  public async closePopOver(): Promise<void> {
    if (!this.profilePopover) {
      this.isUserProfilePopupOpen = false;
      return;
    }

    const popover = this.profilePopover;
    this.profilePopover = null;
    this.isUserProfilePopupOpen = false;
    await popover.dismiss();
  }

  ngOnDestroy() {
    if (this.notificationSub) {
      this.notificationSub.unsubscribe();
    }
  }

  private reorderLanguageOptions() {
    this.orderedLanguageOptions = [
      ...this.languageOptions.filter(language => language.code === this.selectedLanguage),
      ...this.languageOptions.filter(language => language.code !== this.selectedLanguage),
    ];
  }

  private focusLanguageOption(index: number): void {
    const safeIndex = Math.max(0, Math.min(index, this.orderedLanguageOptions.length - 1));

    setTimeout(() => {
      const optionEl = this.languageOptionRefs?.toArray()[safeIndex]?.nativeElement;
      optionEl?.focus();
    }, 0);
  }

  private moveFocusOutsideLanguageDropdown(backwards: boolean): void {
    const trigger = this.languageTrigger?.nativeElement;
    if (!trigger) {
      return;
    }

    const focusableElements = this.getFocusableElements();
    const triggerIndex = focusableElements.indexOf(trigger);

    if (triggerIndex < 0) {
      return;
    }

    const targetIndex = backwards ? triggerIndex - 1 : triggerIndex + 1;
    const targetElement = focusableElements[targetIndex];
    targetElement?.focus();
  }

  private getFocusableElements(): HTMLElement[] {
    const selectors = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled]):not([type="hidden"])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])',
      '[contenteditable="true"]'
    ].join(',');

    return Array.from(document.querySelectorAll<HTMLElement>(selectors)).filter(element => {
      const style = window.getComputedStyle(element);
      return style.visibility !== 'hidden' && style.display !== 'none';
    });
  }
}
